// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"470":"1cd6014e","515":"d52b0adc","621":"878b6f64","745":"2d30e760"}[chunkId] + ".chunk.js";
};